<template>
<div>
  <div>
    <div class="om-trtc-video-box">
      <div class="om-trtc-video">
        <div class="video" id="localVideo"></div>
      </div>
      <div class="om-trtc-video">
        <div class="video" id="remoteVideo"></div>
      </div>
    </div>
    <div style="text-align:center;"><Button @click="webrtcCloseConnect" type="primary">Close</Button></div>
  </div>
  <!-- 浏览器报错指导教程-->
  <div class="tutorial-modal-box" v-if="isTutorialTip">
    <zlr-modal v-model="isTutorialTip"
              :mask-closable=false>
        <div style="width:100%;">
          <video-check-tutorial></video-check-tutorial>
          <div class="btn-center" style="margin-bottom:45px;text-align:center;">
            <Button class="btn"
              @click="isTutorialTip=false">Close</Button>
          </div>
        </div>
    </zlr-modal>
  </div>
  <!-- NotReadableError -->
  <div class="err-modal-box" v-if="isModalError">
    <zlr-modal v-model="isModalError"
            :mask-closable=false>
        <div style="width:100%;">
          <div class="err-modal-box-content">
            <div v-if="modalErrorContent==='NotReadableError'">
              The camera/microphone is temporarily unavailable. <br>Please ensure that the current browser is able to access <br>the camera/microphone and no other applications are <br>occupying the camera/microphone.
            </div>
            <div v-if="modalErrorContent==='NotAllowedError'">
              Please make sure the current browser is able to access the camera/microphone.
            </div>
            <div v-if="modalErrorContent==='NotAllowedErrorOther'">
              Please allow current browser to access the camera/microphone.
            </div>
            <div v-if="modalErrorContent==='NotFoundError'">
              The browser is having trouble detecting the camera/microphone device. <br>Please check the web connection and make sure your current browser<br> is able to access the camera/microphone.
            </div>
            <div v-if="modalErrorContent==='NoMicrophone'">
              The browser is having trouble detecting the microphone device. <br>Please check the web connection and make sure your current browser<br> is able to access the microphone.
            </div>
            <div v-if="modalErrorContent==='NoCamera'">
              The browser is having trouble detecting the camera device. <br>Please check the web connection and make sure your current browser<br> is able to access the camera.
            </div>
            <div v-if="modalErrorContent==='RtcError'">
              Network is abnormal, check the network, firewall, VPN, or other network proxy
            </div>
          </div>
          <div class="btn-center" style="margin-bottom:45px;text-align:center;">
            <Button class="btn"
              @click="isModalError=false">Close</Button>
          </div>
        </div>
    </zlr-modal>
  </div>
</div>
</template>

<script>
import { getOmVideoUserSign, getOmMenteeNum } from '@/api/video'
import TRTC from 'trtc-js-sdk'
import ZlrModal from '_c/modal/modal'
import VideoCheckTutorial from '@/view/mentee/tencent/video-check-tutorial'
export default {
  name: 'om-trtc-video',
  components: {
    ZlrModal,
    VideoCheckTutorial
  },
  data () {
    return {
      // 视频端
      videoClientAttrs: {
        client_: null,
        isJoined_: false,
        isPublished_: false,
        localStream_: null
      },
      userId: '',
      roomId: '',
      // 浏览器报错指导教程
      isTutorialTip: false,
      // 错误弹窗
      isModalError: false,
      modalErrorContent: '',
      // 设备检测
      // has---Device 是否检测到当前系统有---设备
      // has---Connect 是否检测到当前浏览器有---连接
      hasCameraDevice: false,
      hasMicDevice: false,
      hasCameraConnect: null,
      hasMicConnect: null,
      hasVoiceDevice: false,
      hasVoiceConnect: null
    }
  },
  mounted () {
    this.beforeVideoShow()
  },
  methods: {
    // 开始视频前
    beforeVideoShow () {
      // 获取学生num成为房间号
      this.getOmMenteeNum()
      // 设备检测
      this.getDevicesInfo()
    },
    // 获取学生num成为房间号
    getOmMenteeNum () {
      getOmMenteeNum().then(res => {
        if (res.code === 0) {
          this.roomId = res.data.model
          // 获取用户信息
          this.getOmVideoUserSign()
        }
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    },
    // 设备检测
    async getDevicesInfo () {
      // 判断是否为safari浏览器
      const isSafari =
            /Safari/.test(navigator.userAgent) &&
            !/Chrome/.test(navigator.userAgent) &&
            !/CriOS/.test(navigator.userAgent) &&
            !/FxiOS/.test(navigator.userAgent) &&
            !/EdgiOS/.test(navigator.userAgent)
      const isFirefox = /Firefox/i.test(navigator.userAgent)

      // safari和firefox浏览器上检测不到扬声器设备
      const noVoiceDevice = isSafari || isFirefox

      let cameraList = await TRTC.getCameras()
      let micList = await TRTC.getMicrophones()
      let voiceList = await TRTC.getSpeakers()

      this.hasCameraDevice = cameraList.length > 0
      this.hasMicDevice = micList.length > 0
      this.hasVoiceDevice = voiceList.length > 0

      cameraList.forEach(camera => {
        if (camera.deviceId.length > 0) {
          this.hasCameraConnect = true
        }
      })
      micList.forEach(mic => {
        if (mic.deviceId.length > 0) {
          this.hasMicConnect = true
        }
      })
      // 如果是无法进行扬声器检测的浏览器，设置为true
      if (noVoiceDevice) {
        this.hasVoiceDevice = true
        this.hasVoiceConnect = true
        console.log('扬声器检测ios')
      } else {
        this.hasVoiceConnect = voiceList.length > 0
        console.log('扬声器检测')
      }
    },
    // 获取用户信息
    getOmVideoUserSign () {
      getOmVideoUserSign({}).then(res => {
        this.startTrtcVideo(res.data)
        this.userId = res.data.userId
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    },
    // 开始视频
    startTrtcVideo ({ sdkAppId, urlSig, userId }) {
      // let self = this
      try {
        this.videoClientAttrs.client_ = TRTC.createClient({
          mode: 'rtc',
          sdkAppId: sdkAppId,
          userId: userId,
          userSig: urlSig,
          useStringRoomId: true
        })
      } catch (e) {
        console.log(e)
      }
      // 视频端监测事件
      this.watchTrtcVideo()
      // 视频端进房
      this.Join(this.videoClientAttrs)
    },
    // 视频流进房
    async Join (that) {
      let self = this
      if (that.isJoined_) {
        console.warn('duplicate RtcClient.join() observed')
        return
      }

      try {
        await that.client_.join({
          roomId: self.roomId + '-test'
        })
        that.isJoined_ = true
      } catch (e) {
        console.error('join room failed! ' + e)
      }
      // 没有摄像头，只有麦克风
      if (!this.hasCameraConnect && this.hasMicConnect) {
        try {
          that.localStream_ = TRTC.createStream({
            audio: true,
            video: false,
            userId: self.userId,
            mirror: true
          })
        } catch (e) {
          console.error(e)
        }
      } else {
        // 其他
        // 或者有或者没有
        try {
          that.localStream_ = TRTC.createStream({
            audio: true,
            video: true,
            userId: self.userId,
            mirror: true
          })
        } catch (e) {
          console.error(e)
        }
      }
      try {
        that.localStream_.setVideoProfile({ width: 960, height: 540, frameRate: 30, bitrate: 1600 })
        await that.localStream_.initialize()
        console.log('initialize local stream success')
      } catch (e) {
        console.error('failed to initialize local stream - ' + e)
        if (e.name.includes('NotReadableError')) {
          // 暂时无法访问摄像头/麦克风，请确保系统允许当前浏览器访问摄像头/麦克风，并且没有其他应用占用摄像头/麦克风
          this.isModalError = true
          this.modalErrorContent = 'NotReadableError'
        } else if (e.name.includes('NotAllowedError')) {
          if (e.message.includes('Permission denied by system')) {
            // 请确保系统允许当前浏览器访问摄像头/麦克风
            this.isModalError = true
            this.modalErrorContent = 'NotAllowedError'
          } else {
            // 请允许当前浏览器访问摄像头/麦克风
            this.isTutorialTip = true
          }
        } else if (e.name.includes('NotFoundError')) {
          // 浏览器获取不到摄像头/麦克风设备，请检查设备连接并且确保系统允许当前浏览器访问摄像头/麦克风
          this.isModalError = true
          this.modalErrorContent = 'NotFoundError'
        } else if (e.name.includes('RtcError')) {
          if (e.message.includes('no microphone detected')) {
            this.isModalError = true
            this.modalErrorContent = 'NoMicrophone'
          } else if (e.message.includes('no camera detected')) {
            this.isModalError = true
            this.modalErrorContent = 'NoCamera'
          } else {
            this.isModalError = true
            this.modalErrorContent = 'RtcError'
          }
        }
        return
      }

      try {
        // publish the local stream
        await this.publish(that)
        that.localStream_.play('localVideo', { muted: true })
      } catch (e) {
        console.error('failed to publish local stream - ', e)
      }
    },
    // 离开
    async leave (that) {
      if (!that.isJoined_) {
        console.warn('leave() - please join() firstly')
        return
      }
      // ensure the local stream is unpublished before leaving.
      await this.unpublish(that)

      // leave the room
      await that.client_.leave()
      if (that.localStream_) {
        that.localStream_.stop()
        that.localStream_.close()
        that.localStream_ = null
        that.isJoined_ = false
      }
    },
    // 推流
    async publish (clientAttrs) {
      if (!clientAttrs.isJoined_) {
        console.warn('publish() - please join() firstly')
        return
      }
      if (clientAttrs.isPublished_) {
        console.warn('duplicate RtcClient.publish() observed')
        return
      }
      try {
        await clientAttrs.client_.publish(clientAttrs.localStream_)
      } catch (e) {
        console.error('failed to publish local stream ' + e)
        clientAttrs.isPublished_ = false
      }

      clientAttrs.isPublished_ = true
    },
    // 取消推流
    async unpublish (clientAttrs) {
      if (!clientAttrs.isJoined_) {
        console.warn('unpublish() - please join() firstly')
        return
      }
      if (!clientAttrs.isPublished_) {
        console.warn('RtcClient.unpublish() called but not published yet')
        return
      }
      await clientAttrs.client_.unpublish(clientAttrs.localStream_)
      clientAttrs.isPublished_ = false
    },
    // 远端视频流监听
    watchTrtcVideo () {
      let self = this
      let client = this.videoClientAttrs.client_
      // 远端流添加事件，当远端用户发布流后会收到该通知。
      client.on('stream-added', event => {
        console.log('远端流添加事件')
        const remoteStream = event.stream
        // 订阅其他一般远端流
        client.subscribe(remoteStream)
      })
      // 远端流移除事件，当远端用户取消发布流后会收到该通知。
      client.on('stream-removed', event => {
        console.log('远端流移除事件')
        const remoteStream = event.stream
        remoteStream.stop()
      })
      // 远端流更新事件，当远端用户添加、移除或更换音视频轨道后会收到该通知。
      client.on('stream-updated', event => {
        console.log('远端流更新事件')
      })
      // 远端流订阅成功事件，调用 subscribe() 成功后会触发该事件。
      client.on('stream-subscribed', event => {
        console.log('远端流订阅成功事件')
        // rtcLogService.info('远端流订阅成功事件', self.appDetail.id, 'TRTC', 696).then()
        const remoteStream = event.stream
        remoteStream.play('remoteVideo')
      })
      // SDK 和腾讯云的连接状态变更事件，您可以利用该事件从总体上监听 SDK 与腾讯云的连接状态。
      // 若您需要细分监听每一条 Stream 的连接状态，可以监听 StreamEvent.CONNECTION_STATE_CHANGED 事件处理。
      client.on('connection-state-changed', event => {
        console.log('SDK 和腾讯云的连接状态变更事件')
      })
      // 远端用户进房通知
      client.on('peer-join', event => {
        console.log('远端用户进房通知')
      })
      // 远端用户退房通知
      client.on('peer-leave', event => {
        console.log('远端用户退房通知')
      })
      // 网络质量统计数据事件，进房后开始统计，每两秒触发一次，包括上、下行的网络质量数据。
      client.on('network-quality', event => {
        // console.log('网络质量')
      })
      // 错误事件，当出现不可恢复错误后，会抛出此事件
      client.on('error', error => {
        console.error('client error observed: ' + error)
        const errorCode = error.getCode()
        console.log(errorCode)
        self.webrtcCloseConnect()
        location.reload()
        // 请根据错误码列表(https://cloud.tencent.com/document/product/647/34342)查看错误类型。
        // 当出现客户端错误后，请调用 Client.leave() 退房并尝试通过 Client.join() 重新进房恢复通话。
      })
    },
    webrtcCloseConnect () {
      this.leave(this.videoClientAttrs)
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="less">
.om-trtc-video-box{
  display:flex;
  justify-content: space-between;
  margin:30px 0 50px;
  .om-trtc-video{
    width:480px;
    height:320px;
    margin-right:10px;
    background: black;
    display:flex;
  }
}
//错误弹窗
.err-modal-box {
  &-content {
    font-size: 24px;
    padding: 50px;
    color: red;
    text-align: center;
  }
}
</style>
<style>
.tutorial-modal-box .zlr-modal .zlr-modal-main {
  padding-top: 0;
}
